import { MetaIcon } from '@nimbus-ds/icons';
import { MenuButton } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useHandleMenuClick } from 'App/hooks';
import { menuPrimaryMetaClick } from './tracking';

const PATH = '/social/meta/#/';

function MetaMenu() {
  const { t } = useTranslation('common');
  const { hash, pathname } = useLocation();
  const { handleClickItem } = useHandleMenuClick();

  return (
    <MenuButton
      as={Link}
      to={PATH}
      startIcon={MetaIcon}
      onClick={() => {
        menuPrimaryMetaClick();
        handleClickItem();
      }}
      active={`${pathname}${hash}`.startsWith(PATH)}
      label={`${t('menu.salesChannels.more.meta')}`}
    />
  );
}

export default MetaMenu;
